
import { rootApi } from "../user/api";

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ["CreateTour"],
});

export const createTourApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findCreateTourInit: builder.mutation({
      query: () => `create-tour-init/`,
      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),

    findSearchTour: builder.mutation({
      query: (payload) => {
        let url = `create-tour-trip/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
    }),
    getDownloadCSVCreateTour: builder.mutation({
      query: () => ({
        url: `create-tour-trip/download/`,
        method: "GET",
        responseHandler: (response) => response.text(),
      }),
    }),
    createBySystem: builder.mutation({
      query: (payload) => ({
        url: `create-tour-system/init/`,
        method: "POST",
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),
    getProgressBySystem: builder.mutation({
      query: (payload) =>
        `create-tour-system/status/?plan_job_id=${payload.plan_job_id}`,
      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),

    createByManual: builder.mutation({
      query: (payload) => ({
        url: `create-tour/manual-trip/create/`,
        method: "POST",
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),

    createByRemainTrip: builder.mutation({
      query: (payload) => ({
        url: `create-tour/remaining-trip/create/`,
        method: "POST",
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),

    createTourManualDraft: builder.mutation({
      query: (trips) => ({
        url: `create-tour/manual-trip/draft/?trips=${trips}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),

    createTourManualCheck: builder.mutation({
      query: (trips) => ({
        url: `create-tour/manual-trip/check/?trips=${trips}`,
        method: "GET",
      }),

      keepUnusedDataFor: 0,
      providesTags: ["CreateTour"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindCreateTourInitMutation,
  useFindSearchTourMutation,
  useCreateBySystemMutation,
  useCreateByManualMutation,
  useCreateByRemainTripMutation,

  useGetDownloadCSVCreateTourMutation,

  useGetProgressBySystemMutation,
  useCreateTourManualCheckMutation,
  useCreateTourManualDraftMutation,
} = createTourApi;
